import { render, staticRenderFns } from "./ActiveAppConfirmDialog.vue?vue&type=template&id=632c8c88&scoped=true"
import script from "./ActiveAppConfirmDialog.vue?vue&type=script&lang=js"
export * from "./ActiveAppConfirmDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "632c8c88",
  null
  
)

export default component.exports